// extracted by mini-css-extract-plugin
export default {"tooltip":"PersonaLabel_tooltip__7UXKl"};